import axios from '@/lib/AxApi';

export default
{
    selectRow(params, cb)
    {
        axios.get('/KeypadCodes/selectRow',
            {
                params,
            })
            .then((response) =>
            {
                cb(response.data);
            })
            .catch((e) =>
            {
                // TODO
            });
    },
    save(params, cb)
    {
        if (typeof params.id !== 'undefined' && params.id != '')
        {
            axios.post('/KeypadCodes/updateRow', params)
                .then((response) =>
                {
                    cb(response.data);
                })
                .catch((e) =>
                {
                    // TODO
                });
        }
        else
        {
            axios.post('/KeypadCodes/insertRow', params)
                .then((response) =>
                {
                    cb(response.data);
                })
                .catch((e) =>
                {
                    // TODO
                });
        }
    },
    deleteRow(params, cb)
    {
        axios.post('/KeypadCodes/deleteRow', params)
            .then((response) =>
            {
                cb(response.data);
            })
            .catch((e) =>
            {
                // TODO
            });
    },
    syncCode(params, cb)
    {
        axios.post('/KeypadCodes/syncCode', params)
            .then((response) =>
            {
                cb(response.data);
            })
            .catch((e) =>
            {
                // TODO
            });
    },
};
